import React, {FC, useRef} from "react";
import {Button} from "@material-ui/core";
import SignatureCanvas from "react-signature-canvas";
import {v4 as uuidv4} from "uuid";
import {RawAttachmentFile} from "ts/api/attachmentFile";
import {ISignature} from "@evennt-tech/api-v2-core";
import useStyles from "./styles";
import ColorPicker from "../ColorPicker";
import FilePreview from "../FilePreview";

type Props = {
  penColor: string;
  setPenColor: (color: string) => void;
  setPaintedFile: (file: RawAttachmentFile | null) => void;
  signatureToEdit?: ISignature;
  showCanvas: boolean;
  setShowCanvas: React.Dispatch<React.SetStateAction<boolean>>;
  style?: React.CSSProperties;
};

const title = "signature";

const DrawSignature: FC<Props> = ({
  penColor,
  setPenColor,
  setPaintedFile,
  signatureToEdit,
  showCanvas,
  setShowCanvas,
  style,
}) => {
  const classes = useStyles();
  const signatureRef = useRef<SignatureCanvas>(null);

  const handleSaveFile = async () => {
    if (signatureRef.current && !signatureRef.current.isEmpty()) {
      const signatureData = signatureRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");

      try {
        const response = await fetch(signatureData);
        const blob = await response.blob();
        const file = new File([blob], title, {
          type: "image/png",
          lastModified: Date.now(),
        });
        const attachmentFile: RawAttachmentFile = {
          id: uuidv4(),
          title,
          file,
        };
        setPaintedFile(attachmentFile);
      } catch (error) {
        console.error("Error while saving the signature file:", error);
      }
    }
  };
  const handleClearSignature = () => {
    signatureRef.current?.clear();
    setPaintedFile(null);
  };
  const handleRemoveFile = () => {
    setPaintedFile(null);
    setShowCanvas(true);
  };

  if (signatureToEdit?.file && !showCanvas) {
    return (
      <FilePreview
        file={signatureToEdit.file}
        handleRemoveFile={handleRemoveFile}
      />
    );
  }

  return (
    <>
      <ColorPicker penColor={penColor} setPenColor={setPenColor} />
      <SignatureCanvas
        ref={signatureRef}
        penColor={penColor}
        canvasProps={{
          className: classes.signatureCanvas,
          style: {
            backgroundColor: style?.backgroundColor
              ? style.backgroundColor
              : "white",
          },
        }}
        onEnd={handleSaveFile}
      />
      <Button
        onClick={handleClearSignature}
        className={classes.clearSignatureButton}
      >
        Clear Signature
      </Button>
    </>
  );
};

export default DrawSignature;
